/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PublicInputs */

const cs_enum_public = /** @type {(inputs: Enum_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejné`)
};

const en_enum_public = /** @type {(inputs: Enum_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Enum_PublicInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_public = /** @type {((inputs?: Enum_PublicInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PublicInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_public(inputs)
	return cs_enum_public(inputs)
});